var map = {
	"./XVI-logo-anio2-gris-2020.svg": "6e42",
	"./archivo.svg": "81cb",
	"./escudo-XVII-Leg-gris.svg": "250c",
	"./marca-de-verificacion.svg": "b15c",
	"./ornato-maya-01.svg": "c46a",
	"./subir.svg": "1c95",
	"./vector_maya_01.svg": "3984",
	"./vector_maya_02.svg": "2913",
	"./verificacion.svg": "f437"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";